import React from 'react';
import CursorSelection from './CursorSelection';
import * as styles from './LinkCursorSelection.module.scss';
import { useQuill, useQuillState } from './QuillContext';
import { useRangeSaver } from './RangeSaver';

const LinkCursorSelection = () => {
  const { isEditingLink } = useQuillState();
  const { quill } = useQuill();
  const range = useRangeSaver(quill);

  return isEditingLink && range && quill ? (
    <div className={styles.container}>
      <CursorSelection
        className={styles.link}
        quill={quill}
        mark={{ type: 'plain', ...range }}
      />
    </div>
  ) : null;
};

export default LinkCursorSelection;
